import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_7da9f7b2 from 'nuxt_plugin_plugin_7da9f7b2' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_5a0d8e1e from 'nuxt_plugin_pluginutils_5a0d8e1e' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_7a39e82e from 'nuxt_plugin_pluginrouting_7a39e82e' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_a232dfb4 from 'nuxt_plugin_pluginmain_a232dfb4' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginclient_7bb06423 from 'nuxt_plugin_pluginclient_7bb06423' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_3d2c54aa from 'nuxt_plugin_pluginserver_3d2c54aa' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_axios_fe661c86 from 'nuxt_plugin_axios_fe661c86' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_metaplugin_1c4c89ac from 'nuxt_plugin_metaplugin_1c4c89ac' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_20f42f20 from 'nuxt_plugin_iconplugin_20f42f20' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_lazysizesclient_639cb0f0 from 'nuxt_plugin_lazysizesclient_639cb0f0' // Source: ../plugins/lazysizes.client.js (mode: 'client')
import nuxt_plugin_nextDOMUpdate_119c21f3 from 'nuxt_plugin_nextDOMUpdate_119c21f3' // Source: ../plugins/nextDOMUpdate.js (mode: 'all')
import nuxt_plugin_setWebsiteTitle_691642e8 from 'nuxt_plugin_setWebsiteTitle_691642e8' // Source: ../plugins/setWebsiteTitle.js (mode: 'all')
import nuxt_plugin_sleep_052709b4 from 'nuxt_plugin_sleep_052709b4' // Source: ../plugins/sleep.js (mode: 'all')
import nuxt_plugin_elementui_7aa6cf5e from 'nuxt_plugin_elementui_7aa6cf5e' // Source: ../plugins/element-ui.js (mode: 'all')
import nuxt_plugin_matomoclient_66f9a383 from 'nuxt_plugin_matomoclient_66f9a383' // Source: ../plugins/matomo.client.js (mode: 'client')
import nuxt_plugin_smoothscrollclient_b14125e6 from 'nuxt_plugin_smoothscrollclient_b14125e6' // Source: ../plugins/smoothscroll.client.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"hid":"charset","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"theme-color","name":"theme-color","content":"#ffffff"}],"link":[{"hid":"shortcut-icon","rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.553f0c.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.553f0c.png","sizes":"512x512"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.64fbe834.json","hid":"manifest"}],"style":[],"script":[],"title":"","htmlAttrs":{}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_7da9f7b2 === 'function') {
    await nuxt_plugin_plugin_7da9f7b2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5a0d8e1e === 'function') {
    await nuxt_plugin_pluginutils_5a0d8e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7a39e82e === 'function') {
    await nuxt_plugin_pluginrouting_7a39e82e(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_a232dfb4 === 'function') {
    await nuxt_plugin_pluginmain_a232dfb4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_7bb06423 === 'function') {
    await nuxt_plugin_pluginclient_7bb06423(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_3d2c54aa === 'function') {
    await nuxt_plugin_pluginserver_3d2c54aa(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fe661c86 === 'function') {
    await nuxt_plugin_axios_fe661c86(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_1c4c89ac === 'function') {
    await nuxt_plugin_metaplugin_1c4c89ac(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_20f42f20 === 'function') {
    await nuxt_plugin_iconplugin_20f42f20(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_lazysizesclient_639cb0f0 === 'function') {
    await nuxt_plugin_lazysizesclient_639cb0f0(app.context, inject)
  }

  if (typeof nuxt_plugin_nextDOMUpdate_119c21f3 === 'function') {
    await nuxt_plugin_nextDOMUpdate_119c21f3(app.context, inject)
  }

  if (typeof nuxt_plugin_setWebsiteTitle_691642e8 === 'function') {
    await nuxt_plugin_setWebsiteTitle_691642e8(app.context, inject)
  }

  if (typeof nuxt_plugin_sleep_052709b4 === 'function') {
    await nuxt_plugin_sleep_052709b4(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_7aa6cf5e === 'function') {
    await nuxt_plugin_elementui_7aa6cf5e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_matomoclient_66f9a383 === 'function') {
    await nuxt_plugin_matomoclient_66f9a383(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smoothscrollclient_b14125e6 === 'function') {
    await nuxt_plugin_smoothscrollclient_b14125e6(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
